import Config from '../../config/index';
import Matrix from './matrix';
import { __setInstance__ } from './instance';

function init(stageCube: CubeNode): void {
    let defaultConfig: TransformConfig = {
        maxScale: Config.get({
            moduleName: 'transform',
            key: 'maxScale'
        }),
        minScale: Config.get({
            moduleName: 'transform',
            key: 'minScale'
        }),
        scale: Config.get({
            moduleName: 'transform',
            key: 'scale'
        }),
        x: Config.get({
            moduleName: 'transform',
            key: 'x'
        }),
        y: Config.get({
            moduleName: 'transform',
            key: 'y'
        }),
        speed: Config.get({
            moduleName: 'transform',
            key: 'speed'
        })
    };

    let instance: MatrixInstance = new Matrix(stageCube.jView, stageCube.getDropArea(), defaultConfig);

    __setInstance__(instance);
}

export {
    init
};
